<div class="dialog-container">

  <div class="dialog-header">
    <span class="dialog-title">Coordenação</span>
    <div class="flex gap-2 items-center">
      <button class="btn-icon" (click)="load()" [matTooltip]="'Recarregar'"><mat-icon>refresh</mat-icon></button>
      <button class="btn-icon" (click)="close()"><mat-icon>close</mat-icon></button>
    </div>
  </div>

  @if (loading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  <div class="dialog-content">
    @if (!loading) {
      @if (trechos.length === 0) {
        <div class="empty-state">
          <mat-icon>check_circle</mat-icon>
          <p>Nenhuma configuração de coordenação para este contrato.</p>
        </div>
      } @else {
        @for (trecho of trechos; track trecho.tipoTrechoId) {
          <div class="section-card" [class.section-card--pending]="pendingTrechoIds.has(trecho.tipoTrechoId)">
            <div class="section-header">
              <span class="section-title">{{ trecho.tipoTrechoDescricao }}</span>
              @if (pendingTrechoIds.has(trecho.tipoTrechoId)) {
                <span class="pending-badge">
                  <mat-icon>warning</mat-icon>
                  Coordenador necessário
                </span>
              }
            </div>

            <div class="coordenador-rows">
              @for (entry of coordenacaoMap[trecho.tipoTrechoId]; track $index) {
                @if (entry.editing) {
                  <div class="coordenador-edit-row">
                    <div class="coordenador-row-fields">
                      <mat-form-field appearance="outline" class="input-tg coordenador-field-nome">
                        <mat-label>Coordenador</mat-label>
                        <mat-select [(ngModel)]="entry.coordenadorId" [compareWith]="compareById">
                          @for (c of coordenadoresCatalogo; track c.id) {
                            <mat-option [value]="c.id">{{ c.nome }}</mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                      <mat-form-field appearance="outline" class="input-tg coordenador-field-data">
                        <mat-label>Data</mat-label>
                        <input matInput type="date" [(ngModel)]="entry.dataServico" />
                      </mat-form-field>
                      <mat-form-field appearance="outline" class="input-tg coordenador-field-hora">
                        <mat-label>Hora</mat-label>
                        <input matInput type="time" [(ngModel)]="entry.hora" />
                      </mat-form-field>
                      <mat-form-field appearance="outline" class="input-tg coordenador-field-local">
                        <mat-label>Local</mat-label>
                        <input matInput [(ngModel)]="entry.local" />
                      </mat-form-field>
                      <button class="btn-icon btn-confirm-icon" [matTooltip]="'Concluir edição'"
                        (click)="concluirEdicao(trecho.tipoTrechoId, $index)">
                        <mat-icon>check</mat-icon>
                      </button>
                      <button class="btn-icon btn-danger" [matTooltip]="'Remover'"
                        (click)="removerCoordenador(trecho.tipoTrechoId, $index)">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>
                } @else {
                  <div class="coordenador-card">
                    <div class="coordenador-card-info">
                      <div class="coordenador-card-top">
                        <span class="coordenador-nome">{{ entry.nome || nomeCoordenador(entry.coordenadorId) || 'Coordenador não selecionado' }}</span>
                        @if (entry.funcaoDescricao) {
                          <span class="coordenador-funcao">{{ entry.funcaoDescricao }}</span>
                        }
                      </div>
                      <div class="coordenador-meta">
                        @if (entry.dataServico) {
                          <span class="coordenador-meta-item"><mat-icon>event</mat-icon>{{ formatEntryData(entry) }}</span>
                        }
                        @if (entry.hora) {
                          <span class="coordenador-meta-item"><mat-icon>schedule</mat-icon>{{ entry.hora }}</span>
                        }
                        @if (entry.local) {
                          <span class="coordenador-meta-item"><mat-icon>place</mat-icon>{{ entry.local }}</span>
                        }
                        @if (entry.contato) {
                          <span class="coordenador-meta-item"><mat-icon>call</mat-icon>{{ entry.contato }}</span>
                        }
                      </div>
                    </div>
                    <div class="coordenador-card-actions">
                      <button class="btn-icon" [matTooltip]="'Editar'"
                        (click)="editarCoordenador(trecho.tipoTrechoId, $index)">
                        <mat-icon>edit</mat-icon>
                      </button>
                      <button class="btn-icon btn-danger" [matTooltip]="'Remover'"
                        (click)="removerCoordenador(trecho.tipoTrechoId, $index)">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>
                }
              }

              @if (!coordenacaoMap[trecho.tipoTrechoId] || coordenacaoMap[trecho.tipoTrechoId].length === 0) {
                <div class="empty-coordenadores">Nenhum coordenador associado a este trecho.</div>
              }

              @if (addingNew[trecho.tipoTrechoId]) {
                <div class="coordenador-edit-row coordenador-novo-row">
                  <div class="coordenador-row-fields">
                    <mat-form-field appearance="outline" class="input-tg coordenador-field-nome">
                      <mat-label>Coordenador</mat-label>
                      <mat-select [(ngModel)]="novoEntry[trecho.tipoTrechoId].coordenadorId" [compareWith]="compareById">
                        @for (c of coordenadoresCatalogo; track c.id) {
                          <mat-option [value]="c.id">{{ c.nome }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="input-tg coordenador-field-data">
                      <mat-label>Data</mat-label>
                      <input matInput type="date" [(ngModel)]="novoEntry[trecho.tipoTrechoId].dataServico" />
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="input-tg coordenador-field-hora">
                      <mat-label>Hora</mat-label>
                      <input matInput type="time" [(ngModel)]="novoEntry[trecho.tipoTrechoId].hora" />
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="input-tg coordenador-field-local">
                      <mat-label>Local</mat-label>
                      <input matInput [(ngModel)]="novoEntry[trecho.tipoTrechoId].local" />
                    </mat-form-field>
                    <button class="btn-icon btn-confirm-icon" [matTooltip]="'Adicionar'"
                      [disabled]="novoEntry[trecho.tipoTrechoId].coordenadorId == null"
                      (click)="confirmarNovo(trecho.tipoTrechoId)">
                      <mat-icon>check</mat-icon>
                    </button>
                    <button class="btn-icon" [matTooltip]="'Cancelar'"
                      (click)="cancelarNovo(trecho.tipoTrechoId)">
                      <mat-icon>close</mat-icon>
                    </button>
                  </div>
                </div>
              }
            </div>

            <div class="flex justify-between items-center mt-2">
              @if (!addingNew[trecho.tipoTrechoId]) {
                <button mat-button class="btn-tg btn-add-coordenador" (click)="mostrarFormNovo(trecho.tipoTrechoId)">
                  <mat-icon>person_add</mat-icon>
                  Adicionar Coordenador
                </button>
              } @else {
                <span></span>
              }
              <button mat-flat-button class="btn-tg" (click)="definir(trecho.tipoTrechoId)" [disabled]="savingCoordenadores[trecho.tipoTrechoId]">
                @if (savingCoordenadores[trecho.tipoTrechoId]) { Salvando... } @else { Salvar }
              </button>
            </div>
          </div>
        }
      }
    }
  </div>

</div>
